import React, { useEffect, useState } from 'react';
import { RadioButton } from "@shared/ui/atoms/RadioButton";
import { HospitalityActionState, HospitalityMeetingBookingSummary } from "@features/meeting-rooms/pages/models/hospitality.models";
import styled from "styled-components";
import { SimpleSpinner } from "@shared/ui/atoms/SimpleSpinner";
import { updateHospitalityBookingState } from "@features/meeting-rooms/pages/models/hospitality.http";
import { useDispatch, useSelector } from "react-redux";
import { failureNotification } from '@shared/store/notification.duck';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { isCompanyAdminUser, isOfficeAdminUser } from '@shared/utils/AccessControl';

export function HospitalityOrderProgressStateControls(props: Props) {
  const {bookingSummary} = props;
  const status = bookingSummary.status
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const [selectedProgressState, setSelectedProgressState] = useState(HospitalityActionState.NotStarted);
  const [loading, setLoading] = useState(false);

  const hasAccessToUpdate = isCompanyAdminUser(currentUser) || isOfficeAdminUser(currentUser);

  useEffect(() => {
    setSelectedProgressState(status || HospitalityActionState.NotStarted);
  }, [status]);

  const onChange = async (state: HospitalityActionState) => {
    setLoading(true);
    try {
      await updateHospitalityBookingState(bookingSummary.meetingBookingId, state);
      setSelectedProgressState(state);
    } catch (e) {
      dispatch(failureNotification('Failed to update status'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <StateControls>
      {loading ? <SimpleSpinner size={16} /> : <>
        <form>
          <RadioButton style={{marginRight: 24}} value={HospitalityActionState.NotStarted}
                       disabled={loading || !hasAccessToUpdate}
                       selected={selectedProgressState === HospitalityActionState.NotStarted}
                       onChange={() => onChange(HospitalityActionState.NotStarted)}
                       text={'hospitality.not-started'} />
          <RadioButton style={{marginRight: 24}} value={HospitalityActionState.InProgress}
                       disabled={loading || !hasAccessToUpdate}
                       selected={selectedProgressState === HospitalityActionState.InProgress}
                       onChange={() => onChange(HospitalityActionState.InProgress)}
                       text={'hospitality.in-progress'} />
          <RadioButton value={HospitalityActionState.Done}
                       disabled={loading || !hasAccessToUpdate}
                       selected={selectedProgressState === HospitalityActionState.Done}
                       onChange={() => onChange(HospitalityActionState.Done)}
                       text={'hospitality.done'} />
        </form>
      </>}
    </StateControls>
  )
}

interface Props {
  bookingSummary: HospitalityMeetingBookingSummary;
}

const StateControls = styled.div`
  padding: 4px 4px;
  display: inline-flex;
`
